import { useMemo } from "react";
import { cn } from "@/lib/utils";
import { ClipboardListIcon, CheckCircle2Icon } from "lucide-react";
import type { HLDRubricItem } from "@/types/assessment";

interface RubricPanelProps {
  rubric: HLDRubricItem[];
  className?: string;
}

export function RubricPanel({ rubric, className }: RubricPanelProps) {
  const totalWeight = useMemo(
    () => rubric.reduce((sum, item) => sum + item.weight, 0),
    [rubric]
  );

  return (
    <div
      className={cn(
        "rounded-lg border bg-muted/30 p-4 space-y-4",
        className
      )}
    >
      {/* Header */}
      <div className="flex items-center gap-2 text-sm font-medium text-foreground">
        <ClipboardListIcon className="size-4" />
        Evaluation Criteria
      </div>

      {/* Rubric items */}
      <div className="space-y-3">
        {rubric.map((item, index) => (
          <div
            key={index}
            className="flex items-start gap-3 text-sm"
          >
            <CheckCircle2Icon className="size-4 mt-0.5 text-muted-foreground/50" />
            <div className="flex-1 min-w-0">
              <div className="flex items-center justify-between gap-2">
                <span className="font-medium text-foreground">
                  {item.section}
                </span>
                <span className="text-xs text-muted-foreground whitespace-nowrap">
                  {item.weight} pts
                </span>
              </div>
              <p className="text-muted-foreground text-xs mt-0.5 leading-relaxed">
                {item.description}
              </p>
            </div>
          </div>
        ))}
      </div>

      {/* Total */}
      <div className="pt-3 border-t flex items-center justify-between text-sm">
        <span className="text-muted-foreground">Total</span>
        <span className="font-medium">{totalWeight} pts</span>
      </div>
    </div>
  );
}
